/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import React from "react";

export interface RemoveButtonProps {
  onClick: () => void;
  isVisible: boolean;
  isSliderApplicable: boolean;
}

export const RemoveButton: React.FC<RemoveButtonProps> = props => {
  if (!props.isVisible) {
    return null;
  }
  return (
    <div
      className={`${
        props.isSliderApplicable ? "col-md-auto col-auto text-end" : "float-end text-end px-0 mx-0"
      }`}
      css={css`
        margin-left: 5px;
      `}
      onClick={() => {
        props.onClick();
      }}
    >
      <button type="button" className="btn-remove-token p-0" aria-label="Close"></button>
    </div>
  );
};
